// @flow

import type {TreeStructure, TreeItem} from '@pb/kit-component-tree-v2';

export const getNodesByIds = (tree: TreeStructure, nodeIds: Array<string>): TreeStructure => {
    const checkChildren = (children: TreeStructure): TreeStructure =>
        (children ? getNodesByIds(children, nodeIds) : []);

    return tree.reduce((memo: TreeStructure, branch: TreeItem) => {
        if (nodeIds.includes(branch.id)) {
            const {children} = branch;
            return children ? [...memo, {...branch, children: checkChildren(children)}] : [...memo, branch];
        }

        if (branch.children) {
            const nodes = checkChildren(branch.children);
            return nodes.length ? [...memo, {...branch, children: nodes}] : memo;
        }

        return memo;

    }, []);
};
